import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import { AuthProvider } from "@features/auth/AuthContext";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: (echecs, erreur) => {
        // inutile de réessayer une erreur d'autorisation ou de validation
        const statut = (erreur as { statut?: number })?.statut ?? 0;
        return statut >= 500 && echecs < 2;
      },
      refetchOnWindowFocus: false
    }
  }
});

export function Providers({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={client}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
